<script setup>
import {reactive,onMounted} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {userStore} from "@/Stores/UserStore";
import {ToastUtil} from "@/Utils/ToastUtil";

const props = defineProps({
  contextIdA: String,
  contextIdB: String
});

const data = reactive({
  search: null,
  dataLoading: true,
  newDisb: false,
  headers: [
    { title: 'Claim Number', key: 'id' },
    { title: 'Amount', key: 'amount' },
    { title: 'Date', key: 'date' },
    { title: 'Client', key: 'name' },
    { title: 'Insured', key: 'insuredname' },
  ],
  items: [],
  newItem: null
});

const getData = () => {
  let contextIdA = props.contextIdA;
  ApiWrapper.post(
          'disbursements',
          'my-pay-period',
          {payPeriodId: contextIdA}
      )
      .then((response) => {
        if(response.payments){
          data.items = response.payments
        }
      })
      .catch((e)=>{
        ToastUtil.error(e);
      })
      .finally(()=>{
        data.dataLoading = false
      })
}

onMounted(()=>{
  getData()
})
</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar density="compact" flat color="white">
        <v-toolbar-title>Disbursements</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
      <v-row>
        <v-col cols="6">
          <v-text-field density="compact" v-model="data.search" append-icon="mdi-magnify" label="Search" single-line hide-details
                        class="ml-4"></v-text-field>
        </v-col>
      </v-row>
      <v-data-table density="compact" :items="data.items" :headers="data.headers" :search="data.search" :loading="data.dataLoading"
                    loading-text="Loading... Please wait">
        <template v-slot:[`item.amount`]="{ item }">
          <span>{{ item.amount }}</span>
        </template>
        <template v-slot:[`item.client`]="{ item }">
          <RouterLink :to="`/client/${item.clientid}`">
            {{ item.client }}
          </RouterLink>
        </template>
        <template v-slot:[`item.id`]="{ item }">
          <RouterLink :to="`/claim/${item.id}`">
            {{ item.claimnumber }}
          </RouterLink>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<style scoped>
.container {
  padding: 5px;
}

[v-cloak] {
  display: none;
}

.v-list-item-subtitle {
  font-size: 10px !important;
  color:black;
}

.v-toolbar-subtitle {
  color:black !important;
}
</style>